module.exports = __webpack_public_path__ + "static/media/note-icon.d891fe96.svg";